import { BrandMark } from '../brand/BrandMark'
import { useId, type ReactNode } from 'react'
import './AuthStatus.css'

export function AuthStatus({
  product = 'Accounts',
  title = `Opening ${product}`,
  description = 'Just a moment while we check your access.',
  loading = true,
  embedded = false,
  children,
}: {
  product?: 'Accounts' | 'CRM' | 'Workflow' | 'CMS'
  title?: string
  description?: string
  loading?: boolean
  embedded?: boolean
  children?: ReactNode
}) {
  const id = useId()
  const Heading = embedded ? 'h2' : 'h1'
  return (
    <div className={`auth-status${embedded ? ' auth-status--embedded' : ''}`}>
      <section className="auth-status__card" aria-labelledby={id}>
        <p className="auth-status__brand"><BrandMark size={28} />{' ' }SmoothBadger <span>{product}</span></p>
        <div role={loading ? 'status' : undefined} aria-live="polite" aria-atomic="true">
          {loading && <span className="auth-status__spinner" aria-hidden="true" />}
          <Heading id={id} className="auth-status__title">{title}</Heading>
          <p className="auth-status__description">{description}</p>
        </div>
        {children && <div className="auth-status__actions">{children}</div>}
      </section>
    </div>
  )
}
